import { toDateKey } from '../schedule/constants';
import { formatCourseLevel } from '../../utils/courseLevel';

export const ATTENDED = [1];
export const MISSED = [2, 3, 4];

const isPast = (event) => {
  const start = event.start_at
    ? new Date(event.start_at)
    : new Date(`${String(event.date).slice(0, 10)}T${String(event.hour).padStart(2, '0')}:00:00`);

  return !Number.isNaN(start.getTime()) && start.getTime() + 60 * 60 * 1000 < Date.now();
};

export const eventAttendance = (event) => {
  if (!isPast(event)) {
    return 'future';
  }

  const status = Number(event.attendance_status);
  if (ATTENDED.includes(status)) {
    return 'was';
  }
  if (MISSED.includes(status)) {
    return 'miss';
  }

  return 'none';
};

export const dayAttendance = (events = []) => {
  const states = events.map(eventAttendance);

  if (states.includes('miss')) {
    return 'miss';
  }
  if (states.includes('was')) {
    return 'was';
  }

  return '';
};

export const shortLevel = (levelName) => {
  const value = String(levelName || '').trim();
  if (!value) {
    return '';
  }

  const formatted = formatCourseLevel(`Будь-яка мова ${value}`);

  return formatted.startsWith('Рівень ') ? formatted.slice('Рівень '.length) : value;
};

export const groupByDate = (events = []) => {
  const map = {};

  events.forEach((event) => {
    const key = toDateKey(event.date);
    if (!map[key]) map[key] = [];
    map[key].push(event);
  });

  Object.values(map).forEach((list) => list.sort((a, b) => Number(a.hour) - Number(b.hour)));

  return map;
};
